import { render } from "./AddPointVentePage.vue?vue&type=template&id=4d306422&ts=true"
import script from "./AddPointVentePage.vue?vue&type=script&lang=ts"
export * from "./AddPointVentePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__